/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon32Regular = forwardRef('ArrowADownRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M23.584 24.998A1.54 1.54 0 0 1 23.5 25h-13a1 1 0 1 0 0 2h13a3.5 3.5 0 0 0 3.5-3.5v-13a1 1 0 1 0-2 0v13c0 .028 0 .056-.002.084L7.208 5.793a1 1 0 1 0-1.415 1.414l17.79 17.79Z" })));
});
